import { useSelector } from "react-redux";
import { TableCell, TableRow } from "@mui/material";
import { Add } from "@mui/icons-material";
import Button from "../../../../components/Button";
import Table from "../../../../components/Table";
import Pagination from "../../../../components/Pagination";
import { renderTextEllipsis } from "../../../../utils/Helpers";
import { DeleteBgIcon, EditBgIcon } from "../../../../utils/Icons";
import messages from "../../../../assets/locale/messages";
import DeleteExpenseModal from "./ExpenseModals/DeleteExpenseModal";
import AddEditExpenseModal from "./ExpenseModals/AddEditExpenseModal";
import EmptyState from "../../../../components/EmptyState";

const ExpenseTableComponent = ({ expenseTableHook }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { mimarProfit } = messages[lang];

  const {
    // State
    openDeleteConfirm,
    openAddEditExpenseModal,
    mode,
    selectedExpense,
    currentPage,
    isLoading,
    list,
    meta,

    // Handlers
    handleDeleteClick,
    handleCloseDeleteConfirmModal,
    handleDeleteExpense,
    handleCloseAddEditExpenseModal,
    handleOpenAddEditExpenseModal,
    handleAddExpense,
    handleEditExpense,
    handlePageChange,
  } = expenseTableHook;

  // Render the main content based on data availability
  const renderMainContent = () => {
    if (!isLoading && list?.length === 0) {
      return (
        <div className="bg-white rounded-4 categoriess-page d-flex justify-content-center align-items-center flex-column">
          <EmptyState
            subTitle={mimarProfit.expenseTable.noDataDescription}
            showActionButton={false}
          />
        </div>
      );
    } else {
      return (
        <div className="bg-white rounded-4 my-3 categoriess-table-list">
          <Table
            className="rounded-4"
            headlines={[
              mimarProfit.expenseTable.headlines.expenseName,
              mimarProfit.expenseTable.headlines.expenseDate,
              mimarProfit.expenseTable.headlines.expenseAmount,
            ]}
            hasActions={true}
            rows={list?.map((row, i) => (
              <TableRow key={row.expenseName}>
                <TableCell className="start font-regular text-dark-blue fsize-14">
                  {renderTextEllipsis(
                    row[lang === "en" ? "name_en" : "name_ar"] || "-"
                  )}
                </TableCell>
                <TableCell className="font-regular text-dark-blue fsize-14">
                  {renderTextEllipsis(row.date || "-")}
                </TableCell>
                <TableCell className="font-regular text-dark-blue fsize-14">
                  {renderTextEllipsis(row.amount || "0")}
                </TableCell>
                <TableCell className="table-icons-container gap-4">
                  <div className="table-icons-container gap-4">
                    <EditBgIcon
                      className="pointer"
                      onClick={() => handleOpenAddEditExpenseModal("edit", row)}
                    />
                    <DeleteBgIcon
                      className="pointer"
                      onClick={() => handleDeleteClick(row.id)}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          />
          <div className="d-flex justify-content-center py-3">
            <Pagination
              count={meta.pages || 1}
              page={currentPage}
              handleChange={handlePageChange}
              defaultPage={1}
            />
          </div>
        </div>
      );
    }
  };

  return (
    <div className="expense-table-container mt-4">
      {/* Shared Add Button */}
      <div className="add-btn-wrapper mb-4 d-flex justify-content-end">
        <Button
          label={
            <span className="d-flex align-items-center">
              <Add fontSize="large" />
              <span className="ps-1 ">
                {mimarProfit.expenseTable.addExpenseButton}
              </span>
            </span>
          }
          labelClass="fsize-16 text-white pe-2"
          onClick={() => handleOpenAddEditExpenseModal("add")}
        />
      </div>

      {/* Main Content (Table or Empty State) */}
      {renderMainContent()}

      {/* Shared Modals */}
      <AddEditExpenseModal
        open={openAddEditExpenseModal}
        onClose={handleCloseAddEditExpenseModal}
        title={mimarProfit.expenseTable.addEditExpenseModal.title}
        handleAddExpense={handleAddExpense}
        handleEditExpense={handleEditExpense}
        mode={mode}
        selectedExpense={selectedExpense}
      />
      <DeleteExpenseModal
        openDeleteConfirm={openDeleteConfirm}
        handleCloseDeleteConfirmModal={handleCloseDeleteConfirmModal}
        handleDeleteExpense={handleDeleteExpense}
      />
    </div>
  );
};
export default ExpenseTableComponent;
